import _ from 'lodash'
import React from 'react'

import apis from 'browser/app/models/apis'
import ComponentsMap from 'browser/components'
import { ExpandablePanel } from 'browser/components/atomic-elements/atoms/expandable-panel/expandable-panel'
import { ComponentsContext } from 'browser/contexts/components/components-context'
import { PlatformType } from 'shared-libs/models/types/storyboard/storyboard-plan'
import { UIPropMappingContext } from 'shared-libs/components/context/ui-prop-mapping-context'
import { getPropMappingStrategy } from 'browser/contexts/prop-mapping/ui-prop-mapping'
import { EntityFormBlock } from './entity-form-block'
import { EntityFormPanel } from './entity-form-panel'
import OverlayManager from 'browser/components/atomic-elements/organisms/overlay-manager/overlay-manager'

function getExpandableComponentsMap() {
  return {
    ...ComponentsMap,
    'ui:panel': ExpandablePanel,
  }
}

/**
 * Variant of EntityFormPanel that renders the form inside an ExpandablePanel
 * (Gmail-style compose overlay with minimized/normal/expanded states).
 *
 * Swaps the `ui:panel` component mapping so the entity's UI schema renders
 * with ExpandablePanel instead of Panel, without changing the schema itself.
 */
export class ExpandableEntityFormPanel extends EntityFormPanel {
  public static openAndResolveDependencies(
    props: Parameters<typeof EntityFormPanel.openAndResolveDependencies>[0]
  ) {
    const { defaultValue, entityId } = props
    const store = apis.getStore()
    return store
      .createEntities([entityId], this.defaultWithCreationProps(defaultValue))
      .then((entities) => {
        const entity = _.first(entities)
        OverlayManager.openOverlay(this, {
          entity,
          ...props,
        })
        return entities
      })
  }

  public render() {
    const { defaultValue, settings, state, uiSchemaPath, uiContext } = this.props
    const { errors, isFormHidden, entity } = (this as any).state
    const expandableComponentsMap = getExpandableComponentsMap()

    return (
      <div style={isFormHidden ? { display: 'none' } : {}}>
        <ComponentsContext.Provider
          value={{ components: expandableComponentsMap, platform: PlatformType.WEB }}
        >
          <UIPropMappingContext.Provider value={{ getPropMappingStrategy }}>
            <EntityFormBlock
              key="1"
              componentsMap={expandableComponentsMap}
              defaultValue={defaultValue}
              entity={entity}
              errors={errors}
              onClose={(this as any).handleClose}
              onSave={(this as any).handleSave}
              onSelect={(this as any).handleSelect}
              settings={settings}
              state={state}
              uiSchemaPath={uiSchemaPath}
              uiContext={uiContext}
            />
          </UIPropMappingContext.Provider>
        </ComponentsContext.Provider>
      </div>
    )
  }
}
